export default "__VITE_ASSET__B7$sdh32__"